import { BrowserConfiguration } from "models";

export const BrowserConfig: BrowserConfiguration & { loaded: boolean } = {
    baseDomain: 'https://preprod-polizzevita.fidainformatica.it',
    apiBaseDomain: 'https://preprod-polizzevita.fidainformatica.it/bk',

    nMin: 2,
    nMax: 10,
    nLimit: 50,

    loaded: false,
    
    redemptionQuestion: "2.20.20",
    investmentAmountQuestion: "1.30.20",
    "maxInvestmentAmount": 100000000,

    openiddictsettings: {
        authority: "https://localhost:44395",
        // redirectUrl: "https://preprod-mfplus.fidaworkstation.it/comparatore",
        // postLogoutRedirectUri:
        //   "https://preprod-mfplus.fidaworkstation.it/comparatore",
        
        // redirectUrl: "https://preprod-polizzevita.fidainformatica.it/comparatore",
        // postLogoutRedirectUri:
        //   "https://preprod-polizzevita.fidainformatica.it/comparatore",
        redirectUrl: "https://localhost:4200",
        postLogoutRedirectUri:
          "https://localhost:4200",

        clientId: "comparatoreMF",

        scope: "openid profile email roles phone offline_access",
        responseType: "code",
        silentRenew: true,
        renewTimeBeforeTokenExpiresInSeconds: 10,
        useRefreshToken: true,
        ignoreNonceAfterRefresh: true
    }
}